export default "__VITE_ASSET__28006db3__"